module.exports = __webpack_public_path__ + "static/media/scene_incomplete.34744365.svg";